import builder from '../reducerBuilder'
import {
  ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_ERROR,
  ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADED,
  ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADING,
  ACTION_COGOLAND_GET_SCHEDULE_BY_USER_ERROR,
  ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADED,
  ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADING,

} from '../../constants'

export default builder(
  [ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADING, ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADING],
  [ACTION_COGOLAND_GET_SCHEDULE_BY_USER_LOADED, ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_LOADED],
  [ACTION_COGOLAND_GET_SCHEDULE_BY_USER_ERROR, ACTION_COGOLAND_CREATE_SCHEDULE_FOR_USER_ERROR])



// WEBPACK FOOTER //
// ./src/store/cogoland/scheduleReducer.js